import * as React from "react";

/**
 * Hook to manage ResponsiveModal event handlers
 * Centralizes all callbacks with proper memoization
 */
export function useResponsiveModalHandlers(
  onOpenChange: (open: boolean) => void,
  preventCloseWhenLoading: boolean,
  loading: boolean
) {
  // Handle close behavior with loading state
  const handleClose = React.useCallback(() => {
    if (preventCloseWhenLoading && loading) {
      return; // Prevent closing when loading
    }
    onOpenChange(false);
  }, [onOpenChange, preventCloseWhenLoading, loading]);

  return {
    handleClose,
  };
}
